import React from 'react';
import { IntlProvider } from 'react-intl';
import { localeData } from 'i18n/locale';
import { LabelProviderProps } from 'models';

const LabelProvider = ({ children }: LabelProviderProps) => (
	<IntlProvider locale={localeData.localeName} messages={localeData.localeMessages}>
		{children}
	</IntlProvider>
);

export default LabelProvider;
